export default __webpack_public_path__ + "static/media/yantra.5917b8ff.jpg";